// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainRechtsvormEnum =
  (typeof SUREbusinessCommonDomainRechtsvormEnum)[keyof typeof SUREbusinessCommonDomainRechtsvormEnum];

export const SUREbusinessCommonDomainRechtsvormEnum = {
  E: 'E',
  BV: 'BV',
  CO: 'CO',
  CV: 'CV',
  BR: 'BR',
  EV: 'EV',
  KG: 'KG',
  MS: 'MS',
  NV: 'NV',
  OW: 'OW',
  PL: 'PL',
  RD: 'RD',
  SE: 'SE',
  ST: 'ST',
  UR: 'UR',
  VE: 'VE',
  VF: 'VF',
  VV: 'VV',
} as const;
